const o=1;export{o as LowPriority};